import { Box, Icon, Text } from '@zillow/constellation-10';
import { IconLockClosedOutline } from '@zillow/constellation-icons';

type Props = {
  onUpgradeClick: () => void;
};

const PremiumUpgrade = ({ onUpgradeClick }: Props) => (
  <Box
    role="button"
    tabIndex={0}
    onClick={onUpgradeClick}
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onUpgradeClick();
      }
    }}
    css={{ backgroundColor: 'bg.softest', padding: '400', cursor: 'pointer', display: 'flex', alignItems: 'center' }}
  >
    <Icon size="md" css={{ color: 'icon.subtle' }} render={<IconLockClosedOutline />} />
    <Text asChild textStyle="body-sm" color="text.subtle" css={{ marginLeft: '200' }}>
      <span>Upgrade for competitive market insights</span>
    </Text>
  </Box>
);

export default PremiumUpgrade;
